import { Card } from '@/components/ui/card/Card';
import { Skeleton } from '@/components/ui/skeleton';
import { SimpleSelect } from '@/components/form/inputs/SimpleSelect';
import type { Machine } from '../type/Machine';

interface MachinePrefillBlockProps {
  machine: Machine | null;
  t: (key: string) => string;
}

export function MachinePrefillBlock({ machine, t }: MachinePrefillBlockProps) {
  if (!machine) return <Skeleton className="h-16 rounded-xl" />;
  return (
    <Card tier="muted" padding="sm">
      <p className="eyebrow mb-2">{t('traceability.materialTab.prefill.header')}</p>
      <p className="text-base font-semibold text-foreground">{machine.name}</p>
      {(machine.brand || machine.model) && (
        <p className="font-mono text-xs text-muted-foreground mt-1">
          {[machine.brand, machine.model].filter(Boolean).join(' · ')}
        </p>
      )}
      <p className="mt-3 text-xs text-muted-foreground/70 italic">
        {t('traceability.materialTab.prefill.locked')}
      </p>
    </Card>
  );
}

interface MachineSelectBlockProps {
  machines: Machine[];
  value: unknown;
  onChange: (machine: Machine | null) => void;
  t: (key: string) => string;
}

export function MachineSelectBlock({ machines, value, onChange, t }: MachineSelectBlockProps) {
  const selectedId = value !== undefined && value !== null ? Number(value) : null;
  return (
    <SimpleSelect
      id="machine-select"
      aria-label={t('traceability.processSelection.sections.machine')}
      value={selectedId !== null ? String(selectedId) : null}
      onChange={(next) => {
        const id = next ? Number(next) : null;
        onChange(id !== null ? (machines.find((m) => m.id === id) ?? null) : null);
      }}
      noneLabel={t('traceability.processSelection.machineFallback')}
      options={machines
        .filter((m) => m.id !== undefined)
        .map((m) => ({ value: String(m.id), label: m.name }))}
    />
  );
}
